module.exports = __webpack_public_path__ + "~@/assets/img/ipconfig_share.71081cf0.png";